import { LightBulbIcon } from "@heroicons/react/24/solid";
import { cn } from "helpers/classNames";
import { FC } from "react";
import dismissedTipsStore from "store/dismissedTips.store";

interface Props {
  id: string;
  paragraphs: string[];
  className?: string;
}
export const Tips: FC<Props> = ({ id, paragraphs, className }) => {
  const { dismissedTipsIds, addOne } = dismissedTipsStore();
  const isDismissed = dismissedTipsIds.some((_id) => _id === id);
  if (isDismissed) {
    return null;
  }
  return (
    <div className={cn("rounded-md bg-cyan-50 p-4", className)}>
      <div className="mb-3 flex items-center">
        <LightBulbIcon
          className="mr-2 h-5 w-5 text-cyan-400"
          aria-hidden="true"
        />
        <span className="text-sm font-semibold text-cyan-800">Tips!</span>
      </div>
      {paragraphs.map((parra) => (
        <p key={parra} className="mb-4 text-sm text-cyan-900">
          {parra}
        </p>
      ))}

      <div className="flex justify-end">
        <button
          type="button"
          onClick={() => addOne(id)}
          className="ml-3 rounded-md bg-cyan-50 px-2 py-1.5 text-sm font-medium text-cyan-800 hover:bg-cyan-100 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 focus:ring-offset-cyan-50"
        >
          Visa inte igen
        </button>
      </div>
    </div>
  );
};
